import request from '@/utils/request'
const Api = {
    PageFooter: '/Frontend/Page/footer',
    HomeScreen: '/Frontend/Home/screen',
    HomePoster: '/Frontend/Home/poster'
}

/**
 * 底部栏
 * @returns 
 */
export function getPageFooter() {
    return request({
        url: Api.PageFooter,
        method: 'get',
    })
}
/**
 * 海报
 * @returns 
 */
 export function getHomePoster() {
    return request({
        url: Api.HomePoster,
        method: 'get',
    })
}

/**
 * 分屏
 * @returns 
 */
export function getHomeScreen() {
    return request({
        url: Api.HomeScreen,
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/home.js